import gql from 'graphql-tag'

export const RESET_FLEX = gql`
  mutation resetFlex($resetFlex: Boolean!) {
    resetFlex(resetFlex: $resetFlex) @client
  }
`
